import React from 'react';
import {
  Android,
  Biometric_Face_ID,
  Biometric_Touch_ID,
  Biometric_Touch_ID_error,
  Fingerprint_not_recognized,
  OTP_error,
  OTP_one_time_password,
  PIN_code,
  PIN_code_error,
  stars,
  Username_Password,
  Username_Password_error,
  Username_prefilled,
} from '../../../utils/DictionaryManagementUtils';
import { img_icon_face_id, img_icon_touch_id_and, img_icon_touch_id_ios } from '../../../utils/ImagesManagementUtils';
import ClearPageWithCenterIconFP from '../FullPagesComponents/Interaction/ClearPageWithCenterIconFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import PinCodeFP from '../FullPagesComponents/Interaction/PinCodeFP';
import OtpCodeFP from '../FullPagesComponents/Interaction/OtpCodeFP';
import UserNameAndPassFP from '../FullPagesComponents/Interaction/UserNameAndPassFP';
import ClearPageWithCenterIconErrorFP from '../FullPagesComponents/Interaction/ClearPageWithCenterIconErrorFP';

//= ========================================================================
const AuthDF = ({
  globJSON,
  simPlatform,
  language,
  notSkipped,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { auth } = globJSON.configurations.launch;

  return (
    <SimulatorsViewerArrangement>
      {simPlatform === Android
        ? null : (
          <ClearPageWithCenterIconFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            notSkipped={notSkipped}
            imageInsidePage={img_icon_face_id}
            TopTitle={Biometric_Face_ID}
            slideshowRefs={slideshowRefs}
          />
        )}
      <ClearPageWithCenterIconFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        language={language}
        notSkipped={notSkipped}
        imageInsidePage={simPlatform === Android ? img_icon_touch_id_and : img_icon_touch_id_ios}
        TopTitle={Biometric_Touch_ID}
        tintColor={simPlatform === Android ? colors.secondary_font_color : colors.negative_color}
        slideshowRefs={slideshowRefs}
      />
      <PinCodeFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        imageInsidePage={simPlatform === Android ? img_icon_touch_id_and : img_icon_touch_id_ios}
        TopTitle={PIN_code}
        slideshowRefs={slideshowRefs}
      />
      <OtpCodeFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        TopTitle={OTP_one_time_password}
        slideshowRefs={slideshowRefs}
      />
      <UserNameAndPassFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        TopTitle={Username_prefilled}
        slideshowRefs={slideshowRefs}
      />
      <UserNameAndPassFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        TopTitle={Username_Password}
        withoutChangeIdStr
        UserNameHint={auth.username}
        slideshowRefs={slideshowRefs}
      />
      <UserNameAndPassFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        TopTitle={Username_Password_error}
        withoutChangeIdStr
        UserNameHint={auth.username}
        passwordInputText={stars}
        borderColor={colors.negative_color}
        erroMessage
        slideshowRefs={slideshowRefs}
      />
      <PinCodeFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        imageInsidePage={simPlatform === Android ? img_icon_touch_id_and : img_icon_touch_id_ios}
        TopTitle={PIN_code_error}
        withErrorTxt={auth.auth_pin_code_error}
        slideshowRefs={slideshowRefs}
      />
      <OtpCodeFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        withErrorTxt={auth.auth_pin_code_error}
        TopTitle={OTP_error}
        slideshowRefs={slideshowRefs}
      />
      {simPlatform === Android
        ? (
          <ClearPageWithCenterIconFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            language={language}
            notSkipped={notSkipped}
            imageInsidePage={img_icon_touch_id_and}
            TopTitle={Biometric_Touch_ID_error}
            tintColor={colors.negative_color}
            txtMessage={Fingerprint_not_recognized}
            slideshowRefs={slideshowRefs}
          />
        )
        : (
          <ClearPageWithCenterIconErrorFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            notSkipped={notSkipped}
            imageInsidePage={img_icon_face_id}
            TopTitle={Biometric_Face_ID}
            slideshowRefs={slideshowRefs}
          />
        )}
    </SimulatorsViewerArrangement>
  );
};

export default AuthDF;
